import { findMetadataIdByLabel, getMetadataLabel, mapMetadataToSelectItems } from './metadata';

export function getCollegeCapacityHeaders(t) {
	return [
		{ text: t('Код специальности'), value: 'specialty_code', width: 100 },
		{ text: t('Код квалификации'), value: 'qualification_code', width: 120 },
		{ text: t('Форма оплаты'), value: 'payment_type_name', width: 150 },
		{ text: t('Тип подготовки'), value: 'training_type_name', width: 150 },
		{ text: t('Тип образования'), value: 'education_type_name', width: 150 },
		{ text: t('Форма обучения'), value: 'education_form_name', width: 140 },
		{ text: t('Наименование квалификации'), value: 'name', width: 200 },
		{ text: t('Язык обучения'), value: 'study_lang_name', width: 100 },
		{ text: t('Общее количество мест'), value: 'grant_count', width: 100 },
		{ text: t('Целевой грант'), value: 'target_grant_count', width: 100 },
		{ text: t('Оставшиеся места'), value: 'undeveloped', width: 100 },
	];
}

export function mapCollegeCapacityItem(item) {
	if (!item) {
		return {};
	}
	return {
		id: item.id,
		specialty_code: item.speciality || item.specialty_code || '',
		qualification_code: item.qualification_code || '',
		name: item.qualification_name || item.name || '',
		payment_type_name: item.payment_type || '',
		training_type_name: item.traning_type || item.training_type || '',
		education_type_name: item.education_type || '',
		education_form_name: item.education_form || '',
		study_lang_name: item.study_lang || '',
		grant_count: item.places_count != null ? item.places_count : (item.grant_count || 0),
		target_grant_count: item.targer_count != null ? item.targer_count : (item.target_grant_count || 0),
		undeveloped: item.undeveloped != null ? item.undeveloped : 0,
	};
}

export function mapCollegeCapacityList(data) {
	if (!Array.isArray(data)) {
		return [];
	}
	return data.map(mapCollegeCapacityItem);
}

export function getCollegeFilterOptions(metadata) {
	if (!metadata) {
		return {
			paymentType: [],
			trainingType: [],
			educationTypeList: [],
			educationFormList: [],
		};
	}
	return {
		paymentType: mapMetadataToSelectItems(metadata.payment_type),
		trainingType: mapMetadataToSelectItems(metadata.training_type),
		educationTypeList: mapMetadataToSelectItems(metadata.education_type),
		educationFormList: mapMetadataToSelectItems(metadata.education_form),
	};
}

export function filterCollegeCapacityList(list, filters, metadata) {
	if (!Array.isArray(list)) {
		return [];
	}
	let result = list;
	const filterMap = [
		{ key: 'payment_type', filter: filters.paymentType, field: 'payment_type_name' },
		{ key: 'training_type', filter: filters.trainingType, field: 'training_type_name' },
		{ key: 'education_type', filter: filters.educationType, field: 'education_type_name' },
		{ key: 'education_form', filter: filters.educationForm, field: 'education_form_name' },
	];

	filterMap.forEach(({ key, filter, field }) => {
		if (filter == null || filter === '') {
			return;
		}
		const label = getMetadataLabel(metadata && metadata[key], filter);
		if (label) {
			result = result.filter((item) => item[field] === label);
		}
	});

	return result;
}

export function mapCollegeQualificationItem(item, trainingType = null) {
	if (!item) {
		return null;
	}
	const id = item.qualification_id != null ? item.qualification_id : item.id;
	if (id == null) {
		return null;
	}
	return {
		id,
		qualification_code: item.qualification_code || item.code || '',
		specialty_code: item.speciality || item.specialty_code || '',
		name: item.name || item.qualification_name || '',
		training_type: trainingType,
	};
}

const COLLEGE_QUALIFICATION_GROUPS = {
	workers: 2,
	specialists: 1,
	specialities: 1,
	speciality: 1,
};

export function mapCollegeQualificationResponse(data) {
	if (Array.isArray(data)) {
		const all = data.map((item) => mapCollegeQualificationItem(item)).filter(Boolean);
		return { all, byTrainingType: {} };
	}

	const qualifications = (data && data.qualifications) || data;
	if (!qualifications || typeof qualifications !== 'object' || Array.isArray(qualifications)) {
		return { all: [], byTrainingType: {} };
	}

	const byTrainingType = {};
	const all = [];

	Object.entries(qualifications).forEach(([groupKey, items]) => {
		if (!Array.isArray(items)) {
			return;
		}
		const trainingType = COLLEGE_QUALIFICATION_GROUPS[groupKey] || null;
		const mappedItems = items
			.map((item) => mapCollegeQualificationItem(item, trainingType))
			.filter(Boolean);
		if (trainingType != null) {
			byTrainingType[trainingType] = (byTrainingType[trainingType] || []).concat(mappedItems);
		}
		all.push(...mappedItems);
	});

	return { all, byTrainingType };
}

export function mapCollegeQualificationList(data) {
	return mapCollegeQualificationResponse(data).all;
}

export function getCollegeQualificationsForTrainingType(mappedQualifications, trainingTypeId) {
	const normalizedType = trainingTypeId != null && trainingTypeId !== ''
		? Number(trainingTypeId)
		: null;
	if (normalizedType != null && mappedQualifications.byTrainingType[normalizedType]) {
		return mappedQualifications.byTrainingType[normalizedType];
	}

	const list = mappedQualifications.all || [];
	if (normalizedType === 2) {
		return list.filter((item) => String(item.qualification_code).indexOf('3W') === 0);
	}
	if (normalizedType === 1) {
		return list.filter((item) => String(item.qualification_code).indexOf('3W') === -1);
	}
	return list;
}

export function getCollegeStudyLangOptions(metadata) {
	return mapMetadataToSelectItems(metadata && metadata.study_lang).map((item) => ({
		...item,
		short: String(item.id),
	}));
}

export function buildAddCapacityFormData(payload) {
	const formData = new FormData();
	formData.append('qualification_id', payload.qualificationId);
	formData.append('payment_type', payload.paymentType);
	formData.append('training_type', payload.trainingType);
	formData.append('education_form', payload.educationForm);
	formData.append('education_type', payload.educationType);
	formData.append('study_lang', payload.studyLang);
	formData.append('places_count', payload.placesCount);
	formData.append('target_grant_count', payload.targetGrantCount || 0);
	formData.append('ecp', payload.ecp);
	formData.append('password', payload.password);
	return formData;
}

export function buildEditCapacityFormData(payload) {
	const formData = new FormData();
	formData.append('id', payload.id);
	formData.append('places_count', payload.placesCount);
	formData.append('target_grant_count', payload.targetGrantCount || 0);
	formData.append('ecp', payload.ecp);
	formData.append('password', payload.password);
	return formData;
}

export function buildDeleteCapacityFormData(payload) {
	const formData = new FormData();
	formData.append('id', payload.id);
	formData.append('ecp', payload.ecp);
	formData.append('password', payload.password);
	return formData;
}

export function filterCollegeProfileValues(values) {
	if (!values) {
		return {};
	}
	const filtered = {};
	Object.keys(values).forEach((key) => {
		const item = values[key];
		if (item && item.type !== 'file') {
			filtered[key] = item;
		}
	});
	return filtered;
}

const COLLEGE_PROFILE_READ_ONLY_KEYS = ['name', 'bin', 'region'];
const COLLEGE_PROFILE_METADATA_FIELD_MAP = {
	ownership: 'ownership',
	edu_punkt: 'edu_punkt',
	org_type: 'org_type',
};

function getCollegeProfileApiValue(data, key) {
	if (key === 'ownership') {
		return data.ownership ?? data.owner;
	}
	return data[key];
}

function getCollegeProfileApiId(data, key) {
	if (key === 'ownership') {
		return data.ownership_id ?? data.owner_id;
	}
	return data[`${key}_id`];
}

export function getCollegeProfileMetadataOptions(metadata) {
	if (!metadata) {
		return {
			ownership: [],
			edu_punkt: [],
			org_type: [],
		};
	}
	return {
		ownership: mapMetadataToSelectItems(metadata.ownership),
		edu_punkt: mapMetadataToSelectItems(metadata.edu_punkt),
		org_type: mapMetadataToSelectItems(metadata.org_type),
	};
}

function resolveCollegeProfileMetadataId(data, key, metadataKey, rawValue, metadata) {
	const metadataObject = metadata[metadataKey];
	return getCollegeProfileApiId(data, key)
		?? (rawValue != null && rawValue !== '' && /^\d+$/.test(String(rawValue)) ? Number(rawValue) : null)
		?? (metadataObject && rawValue != null && metadataObject[rawValue] != null ? rawValue : null)
		?? findMetadataIdByLabel(metadataObject, rawValue);
}

function resolveCollegeProfileMetadataDisplay(metadataKey, rawValue, resolvedId, metadata) {
	const metadataObject = metadata[metadataKey];
	if (resolvedId != null && metadataObject) {
		const labelFromId = getMetadataLabel(metadataObject, resolvedId);
		if (labelFromId) {
			return labelFromId;
		}
	}
	if (rawValue == null || rawValue === '') {
		return '';
	}
	return String(rawValue);
}

export function applyCollegeProfileUpdates(profileValues = {}, changed = {}, sourceValues = {}) {
	Object.keys(changed).forEach((key) => {
		const target = profileValues[key];
		const source = sourceValues[key];
		if (!target || !source) {
			return;
		}
		if (target.type === 'metadata') {
			target.id = source.id;
			target.value = source.value;
			return;
		}
		if (target.type === 'string') {
			target.value = source.value;
		}
	});
}

export function cloneCollegeProfileValues(values = {}) {
	return JSON.parse(JSON.stringify(values));
}

export function mapCollegeInfoCollegeProfile(data, t, metadata = {}) {
	if (!data) {
		return { values: {} };
	}

	const fields = [
		{ key: 'bin', labelKey: 'БИН' },
		{ key: 'name', labelKey: 'Наименование' },
		{ key: 'region', labelKey: 'Регион' },
		{ key: 'ownership', labelKey: 'Форма собственности' },
		{ key: 'address', labelKey: 'Адрес' },
		{ key: 'phone', labelKey: 'Телефон' },
		{ key: 'email', labelKey: 'Электронная почта' },
		{ key: 'edu_punkt', labelKey: 'Пункт образования' },
		{ key: 'org_type', labelKey: 'Тип организации' },
	];

	const values = {};
	fields.forEach(({ key, labelKey }) => {
		const label = t(labelKey);
		const rawValue = getCollegeProfileApiValue(data, key);

		if (Object.prototype.hasOwnProperty.call(COLLEGE_PROFILE_METADATA_FIELD_MAP, key)) {
			const metadataKey = COLLEGE_PROFILE_METADATA_FIELD_MAP[key];
			const resolvedId = resolveCollegeProfileMetadataId(data, key, metadataKey, rawValue, metadata);
			const displayValue = resolveCollegeProfileMetadataDisplay(metadataKey, rawValue, resolvedId, metadata);

			values[key] = {
				type: 'metadata',
				metadataKey,
				labelKey,
				name: label,
				value: displayValue || '',
				id: resolvedId,
				can_change: true,
				is_required: false,
			};
			return;
		}

		values[key] = {
			type: 'string',
			labelKey,
			name: label,
			value: rawValue != null && rawValue !== '' ? String(rawValue) : '',
			can_change: !COLLEGE_PROFILE_READ_ONLY_KEYS.includes(key),
			is_required: false,
		};
	});

	return { values };
}

const COLLEGE_PROFILE_FORM_FIELDS = ['ownership', 'address', 'phone', 'email', 'edu_punkt', 'org_type'];
const COLLEGE_PROFILE_INTEGER_FIELDS = ['ownership', 'edu_punkt', 'org_type'];

export function buildCollegeProfileFormPayload(values = {}) {
	return {
		ownership: values.ownership && values.ownership.id != null ? values.ownership.id : null,
		address: values.address && values.address.value !== '' ? values.address.value : null,
		phone: values.phone && values.phone.value !== '' ? values.phone.value : null,
		email: values.email && values.email.value !== '' ? values.email.value : null,
		edu_punkt: values.edu_punkt && values.edu_punkt.id != null ? values.edu_punkt.id : null,
		org_type: values.org_type && values.org_type.id != null ? values.org_type.id : null,
	};
}

function normalizeCollegeProfileFormValue(fieldKey, value) {
	if (value === undefined || value === null || value === '') {
		return undefined;
	}
	if (COLLEGE_PROFILE_INTEGER_FIELDS.includes(fieldKey) && /^\d+$/.test(String(value))) {
		return Number(value);
	}
	return value;
}

export function getChangedCollegeProfilePayload(currentValues = {}, snapshot = {}) {
	const current = buildCollegeProfileFormPayload(currentValues);
	const changed = {};

	COLLEGE_PROFILE_FORM_FIELDS.forEach((key) => {
		const currentValue = current[key];
		const snapshotValue = snapshot[key];
		if (String(currentValue ?? '') === String(snapshotValue ?? '')) {
			return;
		}
		const normalized = normalizeCollegeProfileFormValue(key, currentValue);
		if (normalized !== undefined) {
			changed[key] = normalized;
		}
	});

	return changed;
}

export function buildEditCollegeFormData(payload = {}) {
	const formData = new FormData();

	COLLEGE_PROFILE_FORM_FIELDS.forEach((key) => {
		if (!Object.prototype.hasOwnProperty.call(payload, key)) {
			return;
		}
		const value = normalizeCollegeProfileFormValue(key, payload[key]);
		if (value !== undefined) {
			formData.append(key, value);
		}
	});

	return formData;
}

export function getAcsSettingHeaders(t) {
	return [
		{ text: t('Код квалификации'), value: 'qualification_code', width: 180 },
		{ text: t('Наименование квалификации'), value: 'name' },
		{ text: t('Язык обучения'), value: 'lang_study_name', width: 140 },
		{ value: 'actions', sortable: false, align: 'end', width: 140 },
	];
}

export function mapAcsSettingItem(item) {
	if (!item) {
		return {};
	}
	const capacity = item.capacity || {};
	const qualification = capacity.qualification || {};
	const formValues = mapAcsSettingFormValues(item);
	const isConfigured = isAcsSettingConfigured(item);

	return {
		id: item.id,
		acs_id: item.id,
		qualification_id: qualification.id || null,
		qualification_code: qualification.code || '',
		name: qualification.name || '',
		lang_study_name: capacity.study_lang || '',
		payment_type: capacity.payment_type,
		training_type: capacity.training_type,
		education_type: capacity.education_type,
		education_form: capacity.education_form,
		is_have: isConfigured,
		required_predmets_first: formValues.required_predmets_first,
		required_predmets_second: formValues.required_predmets_second,
		profilePredmetsFirst: formValues.profilePredmetsFirst,
		profilePredmetsSecond: formValues.profilePredmetsSecond,
		capacity,
	};
}

export function mapAcsSettingList(data) {
	if (!Array.isArray(data)) {
		return [];
	}
	return data.map(mapAcsSettingItem);
}

export function getAcsSettingCapacityFilters(item) {
	const capacity = (item && item.capacity) || item || {};
	return {
		payment_type: capacity.payment_type,
		training_type: capacity.training_type,
		education_type: capacity.education_type,
		education_form: capacity.education_form,
	};
}

export function filterAcsSettingList(list, filters) {
	if (!Array.isArray(list)) {
		return [];
	}
	return list.filter((item) => {
		const capacityFilters = getAcsSettingCapacityFilters(item);
		if (filters.paymentType != null && filters.paymentType !== ''
			&& Number(capacityFilters.payment_type) !== Number(filters.paymentType)) {
			return false;
		}
		if (filters.trainingType != null && filters.trainingType !== ''
			&& Number(capacityFilters.training_type) !== Number(filters.trainingType)) {
			return false;
		}
		if (filters.educationType != null && filters.educationType !== ''
			&& Number(capacityFilters.education_type) !== Number(filters.educationType)) {
			return false;
		}
		if (filters.educationForm != null && filters.educationForm !== ''
			&& Number(capacityFilters.education_form) !== Number(filters.educationForm)) {
			return false;
		}
		return true;
	});
}

export function initializeAcsSettingFilters(allPlaceList, filters) {
	const nextFilters = {
		paymentType: filters.paymentType,
		trainingType: filters.trainingType,
		educationType: filters.educationType,
		educationForm: filters.educationForm,
	};

	const buildPlaceList = () => filterAcsSettingList(allPlaceList, {
		paymentType: nextFilters.paymentType,
		trainingType: nextFilters.trainingType,
		educationType: nextFilters.educationType,
		educationForm: nextFilters.educationForm,
	});

	if (!allPlaceList.length) {
		return { placeList: [], filters: nextFilters };
	}

	let placeList = buildPlaceList();
	if (placeList.length) {
		return { placeList, filters: nextFilters };
	}

	const capacityFilters = getAcsSettingCapacityFilters(allPlaceList[0]);
	nextFilters.paymentType = Number(capacityFilters.payment_type);
	nextFilters.trainingType = Number(capacityFilters.training_type);
	nextFilters.educationType = Number(capacityFilters.education_type);
	nextFilters.educationForm = Number(capacityFilters.education_form);
	placeList = filterAcsSettingList(allPlaceList, nextFilters);

	return { placeList, filters: nextFilters };
}

export function isAcsSettingConfigured(item) {
	if (!item) {
		return false;
	}
	const values = mapAcsSettingFormValues(item);
	return values.required_predmets_first != null
		|| values.required_predmets_second != null
		|| values.profilePredmetsFirst != null
		|| values.profilePredmetsSecond != null;
}

export function needsAcsSettingPreset(item) {
	return item && !isAcsSettingConfigured(item);
}

function pickAcsSettingField(source, keys) {
	if (!source) {
		return undefined;
	}
	for (let i = 0; i < keys.length; i += 1) {
		if (Object.prototype.hasOwnProperty.call(source, keys[i])) {
			return source[keys[i]];
		}
	}
	return undefined;
}

export function mapAcsSettingFormValues(source = {}) {
	return {
		required_predmets_first: pickAcsSettingField(source, ['required_predmets_first']),
		required_predmets_second: pickAcsSettingField(source, ['required_predmets_second']),
		profilePredmetsFirst: pickAcsSettingField(source, [
			'profilePredmetsFirst',
			'profile_predmets_first',
			'profile_predmet_first',
		]),
		profilePredmetsSecond: pickAcsSettingField(source, [
			'profilePredmetsSecond',
			'profile_predmets_second',
			'profile_predmet_second',
		]),
	};
}

export function mapAcsSettingPresetResponse(responseData) {
	const data = (responseData && responseData.data) || responseData || {};
	return mapAcsSettingFormValues(data);
}

function mapSubjectListItem(item) {
	if (item == null) {
		return null;
	}
	if (typeof item === 'object') {
		const id = item.id != null ? item.id : item.value;
		if (id == null) {
			return null;
		}
		return {
			id: /^\d+$/.test(String(id)) ? Number(id) : id,
			name: item.name || item.text || item.label || String(id),
		};
	}
	return null;
}

function extractSubjectListFromSource(source, keys) {
	if (!source) {
		return [];
	}
	for (let i = 0; i < keys.length; i += 1) {
		const value = source[keys[i]];
		if (Array.isArray(value)) {
			return value.map(mapSubjectListItem).filter(Boolean);
		}
		if (value && typeof value === 'object') {
			return mapMetadataToSelectItems(value);
		}
	}
	return [];
}


function ensureSubjectOptions(list, ids, metadataObject) {
	const result = Array.isArray(list) ? [...list] : [];
	(ids || []).forEach((id) => {
		if (id == null || id === '') {
			return;
		}
		if (result.some((item) => String(item.id) === String(id))) {
			return;
		}
		result.push({
			id: /^\d+$/.test(String(id)) ? Number(id) : id,
			name: getMetadataLabel(metadataObject, id) || String(id),
		});
	});
	return result;
}

export function buildAcsProfilesParams(formValues = {}) {
	const params = {};
	const fields = [
		['required_predmets_first', formValues.required_predmets_first],
		['required_predmets_second', formValues.required_predmets_second],
		['profile_predmets_first', formValues.profilePredmetsFirst],
		['profile_predmets_second', formValues.profilePredmetsSecond],
	];

	fields.forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== '') {
			params[key] = value;
		}
	});

	return params;
}

function collectProfileFieldLabels(data) {
	const labels = {};
	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		return labels;
	}

	[
		'required_predmets_first',
		'required_predmets_second',
		'profile_predmets_first',
		'profile_predmets_second',
	].forEach((key) => {
		const value = data[key];
		if (value && typeof value === 'object' && value.id != null) {
			labels[String(value.id)] = value.name || value.text || value.label || String(value.id);
		}
	});

	const allListItems = [
		...extractSubjectListFromSource(data, [
			'required_predmets',
			'required_predmet',
			'certificate_predmets',
			'certificate_predmet',
			'profile_predmets',
			'profile_predmet',
			'predmets',
			'subjects',
			'list',
		]),
	];
	allListItems.forEach((item) => {
		labels[String(item.id)] = item.name;
	});

	return labels;
}

export function mapProfilesResponseToSubjectLists(responseData, formValues = {}) {
	const data = (responseData && responseData.data) !== undefined
		? responseData.data
		: responseData;

	if (Array.isArray(data)) {
		const list = data.map(mapSubjectListItem).filter(Boolean);
		return {
			certificatePredmetList: ensureSubjectOptions(list, [
				formValues.required_predmets_first,
				formValues.required_predmets_second,
			], collectProfileFieldLabels({})),
			profilePredmetList: ensureSubjectOptions(list, [
				formValues.profilePredmetsFirst,
				formValues.profilePredmetsSecond,
			], collectProfileFieldLabels({})),
		};
	}

	const labelMetadata = collectProfileFieldLabels(data);
	let certificatePredmetList = extractSubjectListFromSource(data, [
		'required_predmets',
		'required_predmet',
		'certificate_predmets',
		'certificate_predmet',
	]);
	let profilePredmetList = extractSubjectListFromSource(data, [
		'profile_predmets',
		'profile_predmet',
	]);

	if (!certificatePredmetList.length && !profilePredmetList.length) {
		const fallbackList = extractSubjectListFromSource(data, ['predmets', 'subjects', 'list']);
		certificatePredmetList = fallbackList;
		profilePredmetList = fallbackList;
	} else if (!profilePredmetList.length) {
		profilePredmetList = certificatePredmetList;
	} else if (!certificatePredmetList.length) {
		certificatePredmetList = profilePredmetList;
	}

	certificatePredmetList = ensureSubjectOptions(certificatePredmetList, [
		formValues.required_predmets_first,
		formValues.required_predmets_second,
	], labelMetadata);
	profilePredmetList = ensureSubjectOptions(profilePredmetList, [
		formValues.profilePredmetsFirst,
		formValues.profilePredmetsSecond,
	], labelMetadata);

	return { certificatePredmetList, profilePredmetList };
}

function appendAcsSettingFormField(formData, key, value) {
	if (value !== undefined && value !== null && value !== '') {
		formData.append(key, value);
	}
}

export function buildAcsSettingFormData(payload) {
	const formData = new FormData();
	appendAcsSettingFormField(formData, 'id', payload.id);
	appendAcsSettingFormField(formData, 'required_predmets_first', payload.required_predmets_first);
	appendAcsSettingFormField(formData, 'required_predmets_second', payload.required_predmets_second);
	appendAcsSettingFormField(formData, 'profile_predmets_first', payload.profilePredmetsFirst);
	appendAcsSettingFormField(formData, 'profile_predmets_second', payload.profilePredmetsSecond);
	appendAcsSettingFormField(formData, 'ecp', payload.ecp);
	appendAcsSettingFormField(formData, 'password', payload.password);
	return formData;
}

const OCCUPANCY_FILTER_KEYS = ['payment_type', 'training_type', 'education_form', 'education_type'];

export function getCollegeOccupancyHeaders(t) {
	return [
		{ text: t('Код квалификации'), value: 'qualification_code', width: 140 },
		{ text: t('Наименование квалификации'), value: 'name' },
		{ text: t('Язык обучения'), value: 'lang', width: 140 },
		{ text: t('Неразвитые места'), value: 'undeveloped_places', width: 140 },
		{ text: t('Заявки'), value: 'orders', width: 100 },
		{ text: t('Разница'), value: 'difference', width: 100 },
	];
}

export function mapCollegeOccupancyItem(row) {
	if (!row || typeof row !== 'object') {
		return null;
	}
	const qualificationCode = Object.keys(row).find((key) => !OCCUPANCY_FILTER_KEYS.includes(key));
	const qualification = qualificationCode ? row[qualificationCode] : {};
	if (!qualificationCode || !qualification || typeof qualification !== 'object') {
		return null;
	}
	return {
		qualification_code: qualificationCode,
		name: qualification.name || '',
		lang: qualification.lang || '',
		undeveloped_places: qualification.undeveloped_places != null ? qualification.undeveloped_places : 0,
		orders: qualification.orders != null ? qualification.orders : 0,
		difference: qualification.difference != null ? qualification.difference : 0,
		payment_type: row.payment_type,
		training_type: row.training_type,
		education_form: row.education_form,
		education_type: row.education_type,
	};
}

export function mapCollegeOccupancyList(data) {
	if (!Array.isArray(data)) {
		return [];
	}
	return data.map(mapCollegeOccupancyItem).filter(Boolean);
}

export function filterCollegeOccupancyList(list, filters) {
	if (!Array.isArray(list)) {
		return [];
	}
	return list.filter((item) => {
		if (filters.paymentType != null && filters.paymentType !== ''
			&& Number(item.payment_type) !== Number(filters.paymentType)) {
			return false;
		}
		if (filters.trainingType != null && filters.trainingType !== ''
			&& Number(item.training_type) !== Number(filters.trainingType)) {
			return false;
		}
		if (filters.educationType != null && filters.educationType !== ''
			&& Number(item.education_type) !== Number(filters.educationType)) {
			return false;
		}
		if (filters.educationForm != null && filters.educationForm !== ''
			&& Number(item.education_form) !== Number(filters.educationForm)) {
			return false;
		}
		return true;
	});
}

export function initializeCollegeOccupancyFilters(allPlaceList, filters) {
	const nextFilters = {
		paymentType: filters.paymentType,
		trainingType: filters.trainingType,
		educationType: filters.educationType,
		educationForm: filters.educationForm,
	};

	const buildPlaceList = () => filterCollegeOccupancyList(allPlaceList, nextFilters);

	if (!allPlaceList.length) {
		return { placeList: [], filters: nextFilters };
	}

	let placeList = buildPlaceList();
	if (placeList.length) {
		return { placeList, filters: nextFilters };
	}

	const firstItem = allPlaceList[0];
	nextFilters.paymentType = Number(firstItem.payment_type);
	nextFilters.trainingType = Number(firstItem.training_type);
	nextFilters.educationType = Number(firstItem.education_type);
	nextFilters.educationForm = Number(firstItem.education_form);
	placeList = filterCollegeOccupancyList(allPlaceList, nextFilters);

	return { placeList, filters: nextFilters };
}

export function getCollegeOrderHeaders(t) {
	return [
		{ text: t('ИИН абитуриента'), value: 'iin', width: 160 },
		{ text: t('ФИО'), value: 'fio', width: 280 },
		{ text: t('Квота приема'), value: 'quota', width: 140 },
		{ text: t('Статус'), value: 'status', width: 180 },
		{ text: '', value: 'actions', sortable: false, width: 120 },
	];
}

export function mapCollegeOrderItem(item) {
	if (!item) {
		return null;
	}
	return {
		id: item.id,
		iin: item.iin || '',
		fio: item.fio || '',
		quota: item.quota || '',
		status: item.status || '',
	};
}

export function mapCollegeOrderList(data) {
	const list = data && data.data;
	if (!Array.isArray(list)) {
		return [];
	}
	return list.map(mapCollegeOrderItem).filter(Boolean);
}

export function getCollegeOrderPaginationMeta(data) {
	const meta = data && data.meta;
	const source = meta && typeof meta === 'object' ? meta : (data || {});
	return {
		total: source.total != null ? Number(source.total) : 0,
		currentPage: source.current_page != null ? Number(source.current_page) : 1,
		perPage: source.per_page != null ? Number(source.per_page) : 15,
		lastPage: source.last_page != null ? Number(source.last_page) : 1,
	};
}

export function parseOrdersPaginatedResponse(responseData) {
	const payload = responseData && responseData.data != null
		? responseData.data
		: responseData || {};
	const items = Array.isArray(payload.data) ? payload.data : [];
	const meta = getCollegeOrderPaginationMeta(payload);
	return {
		items,
		...meta,
	};
}

export function isCollegeOrderRecalled(status) {
	if (!status) {
		return false;
	}
	return String(status).toLowerCase().includes('отозван');
}

export function buildRecallOrderFormData({ id, ecp, password }) {
	const formData = new FormData();
	formData.append('id', id);
	formData.append('ecp', ecp);
	formData.append('password', password);
	return formData;
}

export function buildRejectOrderFormData({ id, reject_reason, ecp, password }) {
	const formData = new FormData();
	formData.append('id', id);
	formData.append('reject_reason', reject_reason || '');
	formData.append('ecp', ecp);
	formData.append('password', password);
	return formData;
}

function normalizeAseGradeValue(grade) {
	if (grade === undefined || grade === null || grade === '') {
		return null;
	}

	return String(grade);
}

function normalizeAseGradeRows(rows) {
	return (Array.isArray(rows) ? rows : [])
		.filter((row) => row && row.certificate_predmet_id != null)
		.map((row) => ({
			certificate_predmet_id: String(row.certificate_predmet_id),
			grade: normalizeAseGradeValue(row.grade),
		}))
		.sort((a, b) => a.certificate_predmet_id.localeCompare(b.certificate_predmet_id));
}

export function createAseGradesSnapshot(rows) {
	return JSON.stringify(normalizeAseGradeRows(rows));
}

export function hasAseGradeChanges(originalSnapshot, currentRows) {
	return originalSnapshot !== createAseGradesSnapshot(currentRows);
}

export function buildAseEditGradeChanges(originalRows, currentRows) {
	const originalMap = {};
	normalizeAseGradeRows(originalRows).forEach((row) => {
		originalMap[row.certificate_predmet_id] = row.grade;
	});

	const currentMap = {};
	normalizeAseGradeRows(currentRows).forEach((row) => {
		currentMap[row.certificate_predmet_id] = row.grade;
	});

	const allIds = new Set([
		...Object.keys(originalMap),
		...Object.keys(currentMap),
	]);
	const changes = [];

	allIds.forEach((subjectId) => {
		const originalGrade = originalMap[subjectId];
		const currentGrade = currentMap[subjectId];

		if (originalGrade === currentGrade) {
			return;
		}

		if (currentGrade === null || currentGrade === undefined) {
			if (originalGrade !== undefined) {
				changes.push({
					certificate_predmet_id: subjectId,
					grade: '',
				});
			}
			return;
		}

		changes.push({
			certificate_predmet_id: subjectId,
			grade: currentGrade,
		});
	});

	return changes;
}

function buildAseCurrentGradeMap(currentRows) {
	const currentMap = {};

	(Array.isArray(currentRows) ? currentRows : [])
		.filter((row) => row && row.certificate_predmet_id != null)
		.forEach((row) => {
			const subjectId = String(row.certificate_predmet_id);
			currentMap[subjectId] = normalizeAseGradeValue(row.grade);
		});

	return currentMap;
}

export function buildAseEditSubmitGrades(originalRows, currentRows) {
	const originalMap = {};
	normalizeAseGradeRows(originalRows).forEach((row) => {
		originalMap[row.certificate_predmet_id] = row.grade;
	});

	const currentMap = buildAseCurrentGradeMap(currentRows);
	const grades = [];
	const seen = new Set();

	Object.keys(originalMap).forEach((subjectId) => {
		const currentGrade = currentMap[subjectId];

		if (currentGrade === null || currentGrade === undefined) {
			grades.push({
				certificate_predmet_id: subjectId,
				grade: '',
			});
			seen.add(subjectId);
		}
	});

	Object.entries(currentMap).forEach(([subjectId, grade]) => {
		if (seen.has(subjectId) || grade === null || grade === undefined) {
			return;
		}

		grades.push({
			certificate_predmet_id: subjectId,
			grade,
		});
		seen.add(subjectId);
	});

	return grades;
}

export function buildAseEditRequest({ id, originalRows, currentRows, ecp, password }) {
	const grades = buildAseEditSubmitGrades(originalRows, currentRows);
	const formData = new FormData();
	formData.append('ecp', ecp);
	formData.append('password', password);

	const params = { id: String(id) };

	grades.forEach((item, index) => {
		params[`grades[${index}][grade]`] = String(item.grade ?? '');
		params[`grades[${index}][certificate_predmet_id]`] = String(item.certificate_predmet_id);
	});

	return { formData, params };
}

const ACS_ORDER_SUBJECT_SLOTS = [
	{
		subjectKey: 'first_subject',
		gradeKey: 'required_first_grade',
		rowType: 'required_first',
	},
	{
		subjectKey: 'second_subject',
		gradeKey: 'required_second_grade',
		rowType: 'required_second',
	},
	{
		subjectKey: 'third_subject',
		gradeKey: 'profile_first_grade',
		rowType: 'profile_first',
	},
	{
		subjectKey: 'fourth_subject',
		gradeKey: 'profile_second_grade',
		rowType: 'profile_second',
	},
];

function normalizeAcsGradesList(value) {
	return Array.isArray(value) ? value : [];
}

export function hasAcsGradeRowName(name) {
	return name != null && String(name).trim() !== '';
}

export function mapAcsGradeModalRows(acsData) {
	if (!acsData) {
		return [];
	}

	return ACS_ORDER_SUBJECT_SLOTS
		.map((slot) => {
			const subject = acsData[slot.subjectKey];
			if (!subject || !hasAcsGradeRowName(subject.name)) {
				return null;
			}

			return {
				slotId: subject.id,
				name: subject.name,
				gradeKey: slot.gradeKey,
				rowType: slot.rowType,
				options: normalizeAcsGradesList(subject.grades_list),
				selectedSubjectId: null,
			};
		})
		.filter(Boolean);
}

export function getAcsGradeModalSelectedGrade(row) {
	if (!row || row.selectedSubjectId == null) {
		return '';
	}

	const selected = row.options.find(
		(item) => Number(item.id) === Number(row.selectedSubjectId),
	);

	return selected?.grade ?? '';
}

export function buildGradeAcsOrderPayload(reqId, rows) {
	const payload = { req_id: reqId };

	rows.forEach((row) => {
		if (row.selectedSubjectId == null) {
			return;
		}

		const idKey = row.gradeKey.replace('_grade', '_id');
		const selected = row.options.find(
			(item) => Number(item.id) === Number(row.selectedSubjectId),
		);

		payload[idKey] = row.selectedSubjectId;
		payload[row.gradeKey] = selected?.grade ?? null;
	});

	return payload;
}

export function getRequestQualificationId(qualificationItem) {
	if (!qualificationItem) {
		return null;
	}

	const nested = qualificationItem.qualification;

	return (
		qualificationItem.qualification_id
		?? nested?.qualification_id
		?? nested?.id
		?? null
	);
}

export function getRequestStudyLang(qualificationItem) {
	if (!qualificationItem) {
		return null;
	}

	const nested = qualificationItem.qualification;

	return (
		qualificationItem.study_lang
		?? qualificationItem.lang_short
		?? qualificationItem.lang
		?? nested?.study_lang
		?? nested?.lang_short
		?? nested?.lang
		?? null
	);
}

export function buildAcsOrderRequestParams({ item, request }) {
	if (!request || !item) {
		return {};
	}

	const education = request.education || {};

	return {
		qualification_id: getRequestQualificationId(item),
		payment_type: request.payment_type,
		training_type: request.training_type,
		education_form: request.education_form,
		education_type: education.education_type ?? request.education_type,
		study_lang: getRequestStudyLang(item),
		req_id: request.id,
	};
}
